var _defs, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 15"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "star_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M7.558.838a.5.5 0 0 1 .884 0l1.889 3.579a.5.5 0 0 0 .356.26l3.988.69a.5.5 0 0 1 .273.84l-2.82 2.902a.5.5 0 0 0-.137.42l.576 4.005a.5.5 0 0 1-.715.52L8.22 12.268a.5.5 0 0 0-.442 0l-3.63 1.786a.5.5 0 0 1-.716-.52l.576-4.005a.5.5 0 0 0-.137-.42l-2.82-2.902a.5.5 0 0 1 .273-.84l3.988-.69a.5.5 0 0 0 .357-.26L7.558.838Z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#D9D9D9",
    clipPath: "url(#star_svg__a)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#7D54D6",
    className: "star_svg__filled",
    clipPath: "url(#star_svg__a)"
  })));
};
export default SvgStar;